export default function ActionAccessWarning() {
  return (
    <em>
      Note: actions created through this integration will be visible to all
      {app.t('agents')} in this account.
    </em>
  )
}
